import React, { lazy } from "react";
import { Route } from "react-router-dom";
const MainRoutes = lazy(() =>
  import(/* webpackChunkName: "mainroutes" */ "./main/routes")
);
const SMSRoutes = lazy(() =>
  import(/* webpackChunkName: "smsroutes" */ "./SMS/routes")
);
const RCSRoutes = lazy(() =>
  import(/* webpackChunkName: "rcsroutes" */ "./RCS/routes")
);
const WhatsAppRoutes = lazy(() =>
  import(/* webpackChunkName: "whatsapproutes" */ "./WhatsApp/routes")
);
const NLPRoutes = lazy(() =>
  import(/* webpackChunkName: "nlproutes" */ "./NLP/routes")
);
const EmailRoutes = lazy(() =>
  import(/* webpackChunkName: "emailroutes" */ "./Email/routes")
);
const WebhookRoutes = lazy(() =>
  import(/* webpackChunkName: "webhookroutes" */ "./Webhook/routes")
);
const WebchatRoutes = lazy(() =>
  import(/* webpackChunkName: "webhookroutes" */ "./Webchat/routes")
);
const TelegramRoutes = lazy(() =>
  import(/* webpackChunkName: "TelegramProviderRoutes" */ "./Telegram/routes")
);
const SmartAgentRoutes = lazy(() =>
  import(
    /* webpackChunkName: "SmartAgentProviderRoutes" */ "./SmartAgent/routes"
  )
);
// const InstagramRoutes = lazy(() =>
//   import(/* webpackChunkName: "InstagramProviderRoutes" */ "./Instagram/routes")
// );

const InstagramRoutes = lazy(() =>
  import(
    /* webpackChunkName: "InstagramProviderRoutes" */ "./InstagramMessage/routes"
  )
);

const FacebookRoutes = lazy(() =>
  import(
    /* webpackChunkName: "FacebookProviderRoutes" */ "./Facebook/routes"
  )
);
const MessengerRoutes = lazy(() =>
  import(
    /* webpackChunkName: "FacebookMessengerProviderRoutes" */ "./FacebookMessenger/routes"
  )
);
const WhatsAppDirectRoutes = lazy(() =>
  import(
    /* webpackChunkName: "WhatsAppProviderRoutes" */ "./WhatsappDirectProvider/routes"
  )
);

const routes = () => [
  <MainRoutes key="MainRoutes" />,
  <SMSRoutes key="SMSRoutes" />,
  <RCSRoutes key="RCSRoutes" />,
  <WhatsAppRoutes key="WhatsAppRoutes" />,
  <NLPRoutes key="NLPRoutes" />,
  <EmailRoutes key="EmailRoutes" />,
  <WebhookRoutes key="WebhookRoutes" />,
  <WebchatRoutes key="WebchatRoutes" />,
  <TelegramRoutes key="TelegramRoutes" />,
  <InstagramRoutes key="InstagramRoutes" />,
  <FacebookRoutes key="FacebookRoutes" />,
  <MessengerRoutes key="MessengerRoutes" />,
  <WhatsAppDirectRoutes key="WhatsAppProviderRoutes" />,
  <SmartAgentRoutes key="SmartAgentRoutes" />,
];

const MessageRoute = () => <Route component={routes} />;

export default MessageRoute;



// WEBPACK FOOTER //
// src/modules/screens/message/routes.js